import { Promotion } from './promotion.class';

export class Porta extends Promotion {}
